import React from 'react';

export const Html = ({ children }) => <span dangerouslySetInnerHTML={{ __html: children }}></span>;
